import './logo.scss'

const Logo = () => {
  return (
    <div className='logo'>
           <span>EZGuitarScales</span> 
    </div>
  )
}

export default Logo;